import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import fetchHandler from "@/fetch/fetchHandler";
import { Button } from "antd";
import { getVersionList, updateFirmwareStatus } from "@/fetch/fetchApi";
import RefreshGrid from "@/utils/refreshGrid";
import Autolinker from "autolinker";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import LinkModal from "./linkModal";
// import { OPERATIONS_LEVEL } from '@/utils/mapObj';

@connect((state) => state)
class DetailList extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      formConfig: null,
      typeOption: [{
        text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
        value: "",
      }, {
        text: "是",
        value: "1",
      }, {
        text: "否",
        value: "0",
      }],
      statusOption: [{
        text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
        value: "",
      }, {
        text: "正常",
        value: "0",
      }, {
        text: "禁用",
        value: "1",
      }],
      linkVisible: false,
      record: {},
      sourceList: [],
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    const param = {
      release: "1",
      status: "0",
    };

    this.fetchApi(param);
  }

  updateStatus = (res, type, value) => {
    let params = {
      frameType: res.frameType,
      frameWork: res.frameWork,
    };
    if (type === "STATUS") {
      params = {
        ...params,
        status: value,
      };
    }
    if (type === "RELEASE") {
      params = {
        ...params,
        release: value,
      };
    }
    fetchHandler(updateFirmwareStatus, params).then((innerres) => {
      if (innerres && innerres.code === "success") {
        this.refresh();
      }
    });
  };

  init() {
    this.setState({
      tableConfig: {
        tableKey: "firmwareVersionDetailTable",
        tableColumns: [
          {
            name: "大版本号", // 7'大版本号',
            key: "frameWork",
            colType: "textCol",
            align: "center",
          }, {
            name: "说明", // '说明',
            key: "info",
            colType: "textCol",
            render: (text) => {
              return <span className='table-html-col' dangerouslySetInnerHTML={{ __html: Autolinker.link(text) }}></span>;
            },
          }, {
            name: "状态", // '状态',
            key: "status",
            colType: "textCol",
            align: "center",
            render: (text) => {
              switch (text) {
                case 0:
                  return "正常";
                case 1:
                  return "禁用";
                default:
                  return text || "--";
              }
            },
          }, {
            name: "是否对外发布", // '是否对外发布',
            colType: "textCol",
            key: "isRelease",
            align: "center",
            render: (text) => {
              switch (text) {
                case 0:
                  return "否";
                case 1:
                  return "是";
                default:
                  return text || "--";
              }
            },
          }, {
            name: "升级方式", // '升级方式',
            key: "isCharging",
            align: "center",
            colType: "textCol",
            render: (text, record) => {
              const results = [];
              if (record.ftpPath && record.ftpPath !== "--") {
                results.push("FTP");
              }
              if (record.ossPath && record.ossPath !== "--") {
                results.push("数据包");
              }
              return results.join("、");
            },
          }, {
            name: "资源链接", // '资源链接',
            key: "statusTypeName",
            colType: "textCol",
            align: "center",
            render: (text, record) => {
              const results = [];
              if (record.ftpPath && record.ftpPath !== "--") {
                results.push({
                  name: "FTP",
                  path: record.ftpPath,
                });
              }
              if (record.ossPath && record.ossPath !== "--") {
                results.push({
                  name: "数据包",
                  path: null,
                });
              }
              return (
                <a onClick={() => {
                  this.setState({ record, sourceList: results, linkVisible: true });
                }}>
                  查看
                </a>);
            },
          },
          {
            name: "最新更新", // '停止原因分类',
            key: "modifyTime",
            colType: "textCol",
            align: "center",
          },
          {
            name: "操作", // 操作
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              {
                type: "href",
                actionName: "下架", // 默认actionName
                // 根据grid数据 自定义显示actionName
                render: (res) => {
                  return res.isRelease === 0 ? (
                    <Button style={{ minWidth: "0px", paddingLeft: 0, paddingRight: 0, margin: 0 }} type="link" disabled={res.status === 1} onClick={() => this.updateStatus(res, "RELEASE", 1)}>发布</Button>
                  ) : (
                    <Button style={{ minWidth: "0px", paddingLeft: 0, paddingRight: 0, margin: 0 }} type="link" disabled={res.status === 1} onClick={() => this.updateStatus(res, "RELEASE", 0)}>下架</Button>
                  );
                },
              },
              {
                type: "href",
                actionName: "启用", // 默认actionName
                // 根据grid数据 自定义显示actionName
                render: (res) => {
                  return res.status === 0 ? "禁用" : "启用";
                },
                handler: (res) => {
                  if (res.status === 0) {
                    this.updateStatus(res, "STATUS", 1);
                  } else {
                    this.updateStatus(res, "STATUS", 0);
                  }
                },
              },
            ],
          },
        ],
        tableChange: () => {

        },
        tableParam: {
          pagecount: 10,
        },
        dataApi: getVersionList,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [

        {
          type: "input",
          placeholder: "大版本号", // '大版本号',
          param: {
            name: "frameWork",
            type: "string",
          },
          labelName: "大版本号", // '故障名称:',
          required: false,
        },
        {
          type: "select",
          options: this.state.statusOption,
          placeholder: this.internationalization.placeholder, // '请选择:',
          param: {
            name: "status",
            type: "string",
          },
          defaultValue: "0",
          labelName: "状态", // '设备类型',
          required: !1,
        },
        {
          type: "select",
          options: this.state.typeOption,
          placeholder: this.internationalization.placeholder, // '请选择:',
          param: {
            name: "release",
            type: "string",
          },
          defaultValue: "1",
          labelName: "是否发版", // '设备类型',
          required: !1,
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              // icon: 'search',
              text: this.internationalization.btn1, // '查询'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "firmwareVersionDetailTable",
      // tablePage: '固件管理'
    };

    return formConfig;
  }

  fetchApi = (param) => {
    param = {
      ...param,
      frameType: window.LayoutTab["tabParam"].firmwareInfo.frameType,
    };
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "firmwareVersionDetailTable", param);
    }
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  refresh = () => {
    RefreshGrid(this.context.store, "firmwareVersionDetailTable");
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
        {
        this.state.linkVisible && (
          <LinkModal
            sourceList={this.state.sourceList}
            visible
            onCancel={() => this.setState({ linkVisible: false })}
        />
        )
      }

      </div>);

    return Content;
  }
}

export default injectIntl(DetailList);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/firmwareVersionManage/detailList.js